import cookie from 'lib/cookie'
import { ReduxState, User } from 'lib/_types'
import get from 'lodash/get'
import { userApi } from './api/yay/user'

/**
 * auth
 */
export const selectIsLoggedIn = (state) => {
  const userExists =
    typeof userApi.endpoints.getCurrentUser.select()(state)?.data?.id !==
    'undefined'
  const cookiesExist =
    typeof cookie.accessToken.get() !== 'undefined' &&
    typeof cookie.userId.get() !== 'undefined'

  return userExists || cookiesExist
}
// /*

/*
 * user groups selectors
 * */
export const selectUserGroupListCurrentPage = (state) =>
  get(state, 'usersGroups.meta.page', -1)

// inject is_joined: true because api doesn't return this field
export const selectUserGroups = (state) => {
  return {
    ...state.userGroups,
    data: get(state, 'userGroups.data', []).map((group) => ({
      ...group,
      is_joined: true,
    })),
  }
}

/*
 * groups selector
 * */
export const selectGroups = (state) => state.groups
export const selectPopularGroups = (state) => get(state, 'groups.popular', {})
export const selectSideBarGroupListByCategory = (state) => {
  return {
    ...get(state, 'groups.sidebarGroupsCategory', {}),
    categoryId: get(state, 'group.data.group_category_id'),
  }
}
export const selectGroupsMembers = (state) => state.groupsMembers

/*
 * user Search
 * */
export const selectRecentlyLoginUsers = (state) =>
  state.userSearch.recentlyLogin
export const selectVipUsers = (state) => state.userSearch.vipUsers
export const selectHimanowUsers = (state) => state.userSearch.himanow
export const selectSearchUsers = (state) => state.userSearch.search
export const selectSocialSearchUsers = (state) => state.userSearch.socialShare

/*
 * popup
 * */
export const selectErrorPopupCode = (state) =>
  get(state, 'popup.errorPopup.data', '')

/*
 * ranking
 * */
export const selectRanking = (state) => get(state, 'ranking', {})

/*
 * conference call
 * */
export const selectAnonymousCallList = (state) =>
  get(state, 'conferenceCall.anonymousCallList', {})
export const selectCallTimeline = (state) =>
  get(state, 'conferenceCall.callTimeline', {})
export const selectFollowerCallTimeline = (state) =>
  get(state, 'conferenceCall.followerCallTimeline', {})
export const selectCallTimelineFilters = (state) =>
  state?.conferenceCall?.callTimelineFilters || {}

/*
 * password
 * */
export const selectForgotPassword = (state) => get(state, 'password.forgot', {})

/*
 * ui state
 * */
export const selectIsSuggestLoginPopupActive = (state) =>
  get(state, 'uiState.isSuggestOpenAppPopupActive', false)
export const selectBreadcrumb = (state) => get(state, 'uiState.breadcrumb', [])
export const selectIsMeaningfulTime = (state) =>
  get<{
    state: boolean
    force?: boolean
  }>(state, 'uiState.isMeaningfulTime', { state: false })

/*
 * following
 * */
export const selectActiveFollowings = (state) =>
  get(state, 'activeFollowings', {})

/*
 * user
 * */
export const selectUsersDiscover = (state) => get(state, 'usersDiscover', {})

/**
 * mics
 */
export const selectStateIsLoading = (key) => (state) =>
  get(state, `${key}.isLoading`, false)
